import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpResponseDto } from "../model/common/httpResponseDto";
import { OwnerDropDown } from "../model/common/ownerDropDown";
import { ManagementCompany } from "../model/enrollment/managementCompanies";
import { DeactivateProperty } from "../model/properties/deactivateProperty";
import { PropertyDetailDto } from "../model/properties/propertyDetailDto";
import { PropertyList } from "../model/properties/propertyList";
import { PropertyManagementCompany } from "../model/properties/propertyManagementCompany";
import { RentalProperty } from "../model/properties/rentalProperty";
import { RentalPropertyOwner } from "../model/properties/rentalPropertyOwners";
import { RentalPropertyTaxRepresentativeInfo } from "../model/properties/rentalPropertyTaxRepresentativeInfo";
import { TaxRepresentative } from "../model/properties/taxRepresentative";
import { InsertPropertyDto } from "../model/properties/createProperty/createNewProperty";
import { RentalPropertyLicense } from "../model/properties/rentalPropertyLicense";


@Injectable({
    providedIn: 'root'
  })
  export class PropertyService {
    [x: string]: any;
    private baseUrl = `${environment.apiUrl}`;
  
    constructor(private http: HttpClient,private readonly router: Router) {}
     httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
           'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
        })
      };

      getProperties(accountId: string): Observable<PropertyList[]> {
        return this.http.get<PropertyList[]>(`${this.baseUrl}/rentalProperty/external/getRentalProperties/${accountId}`,  this.httpOptions);
      }

      getProperty(id: string): Observable<PropertyDetailDto> {
        return this.http.get<PropertyDetailDto>(`${this.baseUrl}/rentalProperty/external/getRentalProperty/${id}`,  this.httpOptions);
      }

      getAutoCompleteProperty(name : string): Observable<PropertyManagementCompany[]> {
        return this.http.get<PropertyManagementCompany[]>(`${this.baseUrl}/propertyAccount/getPropertyAccountByName/${name}`,  this.httpOptions);
      }

      getPropertiesOwners(accountId : string): Observable<OwnerDropDown[]> {
        return this.http.get<OwnerDropDown[]>(`${this.baseUrl}/rentalProperty/external/getAccountPropertyOwners/${accountId}`,  this.httpOptions);
      }
 
      updateProperty(model: RentalProperty, accountId : string): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/updateRentalProperty`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
      }

      updateOwners(model:RentalPropertyOwner[]): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/updateRentalPropertyOwners`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
      }

      deactivateProperty(model:DeactivateProperty): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/deactivateProperty`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
      }

      updateCompanies(model:ManagementCompany[]): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/updateRentalPropertyCompanies`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
      }
      updateRentalPropertyLicense(model:RentalPropertyLicense): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/updateRentalPropertyLicense`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
       
      }
      updateRentalPropertyTaxRepresentativeInfo(model:RentalPropertyTaxRepresentativeInfo): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/updateRentalPropertyShort`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
       
      }

      updateTaxRepresentative(model:TaxRepresentative): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/updateRentalPropertyTaxRepresentative`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
      }

      createNewRentalProperty(model:InsertPropertyDto): Observable<HttpResponseDto>{
        return this.http.post<HttpResponseDto>(`${this.baseUrl}/rentalProperty/external/createProperty`, model, this.httpOptions).pipe(tap(data => {
          return data
       }));
      }
  
}